import { LOCALES } from 'Constants/General';
import ISOStringToDate from 'Utils/ISOStringToDate';
import {
  userListDevelopmentPlan,
  departmentList,
  terminalList,
  jobTitleList,
  courseListDevelopmenPlan,
  courseCategoryList,
} from './Request';

const mapEmployees = employees =>
  employees.map(employee => [
    employee.fullName || null,
    employee.Department.name || null,
    employee.JobTitle.name || null,
    employee.pendingCourses,
    `${employee.totalCourses - employee.pendingCourses}/${employee.totalCourses}`,
    !employee.lastAssess ? null : Intl.DateTimeFormat(LOCALES).format(ISOStringToDate(employee.lastAssess)),
  ]);

const mapEmployeesObjects = employees =>
  employees.map(employee => ({
    fullName: employee.fullName || null,
    department: employee.Department.name || null,
    jobTitle: employee.JobTitle.name || null,
    pendingCourses: employee.pendingCourses,
    progress: `${employee.totalCourses - employee.pendingCourses}/${employee.totalCourses}`,
    lastEvaluation: !employee.lastAssess
      ? null
      : Intl.DateTimeFormat(LOCALES).format(ISOStringToDate(employee.lastAssess)),
  }));

const mapCourses = courses =>
  courses.map(course => [
    course.name,
    course.Priority.name,
    course.totalUsers,
    course.CourseCategory.name,
    `${course.completedUsers}/${course.totalUsers}`,
    course.id,
  ]);

const mapCoursesObject = courses =>
  courses.map(course => ({
    name: course.name,
    priority: course.Priority.name,
    totalUsers: course.totalUsers,
    category: course.CourseCategory.name,
    progress: `${course.completedUsers}/${course.totalUsers}`,
    id: course.id,
  }));

const objectToArray = arrayObject => arrayObject.map(object => object?.name);

const fetchAreas = async () => {
  const promises = [];
  promises.push(departmentList());
  promises.push(terminalList());
  promises.push(jobTitleList());
  promises.push(courseCategoryList());

  const data = await Promise.all(promises);
  const department = objectToArray(data[0]);
  const terminal = objectToArray(data[1]);
  const jobTitle = objectToArray(data[2]);
  const categories = objectToArray(data[3]);

  return { terminal, department, jobTitle, categories };
};

const fetchUserDevelopmentPlan = async ({
  name = null,
  department = [],
  terminal = [],
  jobTitle = [],
  startDate = null,
  endDate = null,
  limit = 10,
  offset = 0,
  asObject = false,
} = {}) => {
  const params = {};
  if (name !== null) params.name = name;
  if (department.length > 0) params.department = department;
  if (terminal.length > 0) params.terminal = terminal;
  if (jobTitle.length > 0) params.jobTitle = jobTitle;
  if (startDate !== null) params.startDate = startDate;
  if (endDate !== null) params.endDate = endDate;

  const response = await userListDevelopmentPlan({
    ...params,
    limit,
    offset,
  });
  const { count = 0, rows = [] } = response;
  let employees;
  if (asObject) {
    employees = mapEmployeesObjects(rows);
    return { employees };
  }
  employees = mapEmployees(rows);
  return { employees, count };
};

const fetchCourseDevelopmentPlan = async ({
  name = null,
  terminal = null,
  limit = 10,
  offset = 0,
  asObject = false,
} = {}) => {
  const response = await courseListDevelopmenPlan({
    name,
    terminal,
    limit,
    offset,
  });
  const { count = 0, rows = [] } = response;
  let courses;
  if (asObject) {
    courses = mapCoursesObject(rows);
    return { courses };
  }
  courses = mapCourses(rows);
  return { courses, count };
};

export { fetchAreas };
export { fetchUserDevelopmentPlan };
export { fetchCourseDevelopmentPlan };
export default {
  fetchAreas,
  fetchUserDevelopmentPlan,
  fetchCourseDevelopmentPlan,
};
